/**
 * Icon Loader — Main Entry Point
 *
 * Orchestrates loading of all FontAwesome icons used in the mobile app.
 * Mirror of the web app's /icons/index.js pattern.
 *
 * USAGE:
 *   Import and call loadIcons() once at app startup (App.tsx or index.ts).
 *
 *   import loadIcons from './icons';
 *   loadIcons();
 *
 * ARCHITECTURE:
 *   - Icons are split into feature-based modules (core, ai, navigation, etc.)
 *   - Each module registers its icons with FontAwesome's global library
 *   - Components use <FontAwesomeIcon icon={['fad', 'sparkles']} /> unchanged
 *
 * ADDING ICONS:
 *   Find the appropriate category file and add the import + library.add() call.
 *   If a new category is needed, create a new *.icons.ts and import it here.
 */

import { loadCoreIcons } from './core.icons';
import { loadAIIcons } from './ai.icons';
import { loadSuggestionsIcons } from './suggestions.icons';
import { loadSurveyIcons } from './survey.icons';
import { loadNavigationIcons } from './navigation.icons';
import { loadMessagingIcons } from './messaging.icons';
import { loadUserIcons } from './users.icons';
import { loadBrandIcons } from './brands.icons';
import { loadHealthIcons } from './health.icons';
import { loadSnapshotIcons } from './snapshots.icons';
import { loadAdminIcons } from './admin.icons';

const loadIcons = () => {
  loadCoreIcons();
  loadAIIcons();
  loadSuggestionsIcons();
  loadSurveyIcons();
  loadNavigationIcons();
  loadMessagingIcons();
  loadUserIcons();
  loadBrandIcons();
  loadHealthIcons();
  loadSnapshotIcons();
  loadAdminIcons();
};

export default loadIcons;
